import styled from "styled-components";

import { windowWidth } from "@styles/global";

// Telluria
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

const Container = styled.div`
  padding: 0 30px 100px 30px;

  > :not(:last-child) {
    margin-bottom: 15px;
  }
`;

const ContainerShowMoreButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export { Container, ContainerShowMoreButton };
